export enum ConfiguracoesTamanho {
    LARGURADESKTOP = '650px',
    ALTURADESKTOP = '416px',
    MAXTAMANHOMOBILE = '(max-width: 639px)',
    LARGURAMOBILE = '100%',
    ALTURAMOBILE = 'auto',
    TELAPEQUENA = 'sm',
    TAMANHOMOBILE = 639,
}
